<template>
  <!--
    WHAT: Full-page wrapper for the "Quality Metrics" artifact. Quality metrics
          are a SETUP surface (assign/configure measures), NOT a join-authoring
          list→detail flow, so this is a standalone manager rather than an
          ArtifactList + ArtifactDetail pair.
    WHERE: Rendered directly by MetricStudio.vue as the body for the Quality
           artifact tab (registry `manager` / `fullManager: true`).
    CONTRACT: No props. No emitted events. Simply mounts and scrolls the wrapped
              manager; all state lives inside QualityMetricSetup.
    NOTES: Wraps Metric/Metric_Builder/QualityMetricSetup.vue — a pre-existing v1
           component reused VERBATIM by the redesign and shared with other parts
           of the app. Do NOT restyle QualityMetricSetup (or assume it's exclusive
           to Metric Studio) without checking its other callers. Only the scroll
           chrome here is redesign-local.
  -->
  <div class="h-full overflow-y-auto ms2-scroll">
    <QualityMetricSetup />
  </div>
</template>

<script>
import QualityMetricSetup from '@/components/Metric/Metric_Builder/QualityMetricSetup.vue';

export default {
  name: 'QualityManager',
  components: { QualityMetricSetup },
};
</script>

<style scoped>
.ms2-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
.ms2-scroll::-webkit-scrollbar-thumb { background: #D1D5DB; border-radius: 10px; border: 3px solid transparent; background-clip: content-box; }
</style>
